import ListGroup from 'react-bootstrap/es/ListGroup';
import { default as ListGroupItem } from './ListGroupItem';
ListGroup.ListGroupItem = ListGroupItem;
export default ListGroup;